if (!customElements.get('instagram-video-hero')) {
  customElements.define(
    'instagram-video-hero',
    class InstagramVideoHero extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.instagram-video-hero__video');
        if (!this.video) return;

        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onBreakpointChange = this.applySources.bind(this);
        this.desktopQuery.addEventListener('change', this.onBreakpointChange);

        this.applySources();
      }

      disconnectedCallback() {
        if (this.desktopQuery) {
          this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
        }
      }

      applySources() {
        const data = this.video.dataset;
        let sources;

        if (this.desktopQuery.matches) {
          sources = [
            { src: data.desktopWebm, type: 'video/webm' },
            { src: data.desktopMp4, type: 'video/mp4' },
          ];
        } else {
          sources = [
            { src: data.mobileWebm, type: 'video/webm' },
            { src: data.mobileMp4, type: 'video/mp4' },
            { src: data.desktopWebm, type: 'video/webm' },
            { src: data.desktopMp4, type: 'video/mp4' },
          ];
        }

        sources = sources.filter((source) => source.src);
        if (!sources.length) return;

        const currentSource = this.video.querySelector('source');
        if (currentSource && currentSource.src === sources[0].src) return;

        this.video.querySelectorAll('source').forEach((source) => source.remove());
        sources.forEach(({ src, type }) => {
          const source = document.createElement('source');
          source.src = src;
          source.type = type;
          this.video.appendChild(source);
        });

        this.video.muted = true;
        this.video.load();

        if (this.reducedMotionQuery.matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
        } else {
          this.video.play().catch(() => {});
        }
      }
    }
  );
}
